import { render } from "./HomeStyles.vue?vue&type=template&id=036dd13c&scoped=true"
import script from "./HomeStyles.vue?vue&type=script&lang=js"
export * from "./HomeStyles.vue?vue&type=script&lang=js"

import "./HomeStyles.vue?vue&type=style&index=0&id=036dd13c&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036dd13c"]])

export default __exports__